import React, { useContext } from "react";
import styles from "../dashboard.module.scss";
import { Link, useNavigate } from "react-router-dom";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import AuthContext from "../../../hooks/authContext";
import { Button } from "../../../components/ui/button";

const CommunicationsCard = ({ icon, updates, title, count, to, viewAll, client, channels }) => {

    const navigate = useNavigate();
    const auth = useContext(AuthContext);

    const redirectToInviteClient = () => {
        navigate("/peoples/createClient");
    }

    const handleShareClick = (id) => {
        if (title === "My Tickets" || title === "Team Issues"){
          navigate(`${to}/${id}`)  
        } else if (title === "Team Messages" || title === "Client Messages"){
            const data = channels?.find((item)=> item?.id === id);
            auth?.setCurrentChannel(data);
            navigate(to);
        } else if(title === "Supply Requests") {
            auth?.setSupplyId(id);
            navigate(to);
        } else {
            navigate(to);
        }
    }

    return (
    <>
        {client === true ? (
        <div className={`${styles.card} bg-white dark:bg-[#1A1F2C] text-[#020817] dark:text-white dark:border-0 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
            <div className="p-16">
            <div className="d-flex flex-center flex-space-between">
                <div className={styles.headerLeft}>
                {icon}
                <div className={`${styles.headerTitle} dark:text-white`}>{title}</div>
                </div>
                <div className={styles.notificationBadge}>{count} new</div>
            </div>
            </div>
            <div className={styles.cardContent}>
            <div
                className="d-flex flex-direction-column flex-center mt-20 p-6 bg-[#FAF5FF] dark:bg-purple-950 rounded"
                style={{ borderRadius: "4px" }}
            >
                <div className="mt-35">
                <PeopleOutlineIcon className="text-purple-500 dark:text-purple-300" style={{ fontSize: "3.1875rem" }} />
                </div>
                <div className="mt-10 text-[#6B21A8] dark:text-purple-200 font-semibold text-base leading-5">
                Invite your clients to communicate
                </div>
                <div className="mt-10 mh-10 text-[#7E22CE] dark:text-purple-300 text-sm leading-5 text-center">
                Speed up response time, centralize client feedback and improve overall client satisfaction.
                </div>
                <div className="mv-15">
                <Button
                    variant=""
                    onClick={() => redirectToInviteClient()}
                    className="bg-[#9333EA] dark:bg-purple-600 hover:bg-purple-700 text-white text-[15px] rounded"
                >
                    Invite Clients
                </Button>
                </div>
            </div>
            </div>
        </div>
        ) : updates?.length > 0 ? (
        <div className={`${styles.card} bg-white dark:bg-[#1A1F2C] text-[#020817] dark:text-white dark:border-0 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
            <div className="p-16">
            <div className="d-flex flex-center flex-space-between">
                <div className={styles.headerLeft}>
                {icon}
                <div className={`${styles.headerTitle} dark:text-white`}>{title}</div>
                </div>
                <div className={styles.notificationBadge}>{count} new</div>
            </div>
            </div>
            <div className={styles.cardContent}>
            {updates?.map((update, index) => (
                <div key={index} className={styles.updateItem}>
                <div className={styles.updateTop}>
                <span className={`${styles.user} dark:text-white`}>
                    {title === "Team Issues" && (
                      <span className="mr-6">Issue #{update?.issueNumberInt}</span>  
                    )}
                    {title === "Supply Requests" && (
                      <span className="mr-6">Supply #{update?.orderNumber}</span>  
                    )}{update.user}</span>
                <span className={`${styles.time} dark:text-white`}>{update.time}</span>
                </div>
                <p className={`${styles.preview} dark:text-[#94A3B8] d-flex flex-space-between flex-center`}>
                    {update?.preview
                    ? update.preview.length > 50
                        ? update.preview.substring(0, 50) + "..."
                        : update.preview
                    : ""}
                    <span style={{ cursor: "pointer" }} onClick={() => handleShareClick(update?.id)}>
                    <ArrowOutwardIcon fontSize="small" />
                    </span>
                </p>
                </div>
            ))}
            <div>
                <Link to={viewAll} className="link text-blue-600 dark:text-blue-400 underline">
                View all
                </Link>
            </div>
            </div>
        </div>
        ) : (
        <div className={`${styles.card} bg-white dark:bg-[#1A1F2C] text-[#020817] dark:text-white dark:border-0 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
            <div className="p-16">
            <div className="d-flex flex-center flex-space-between">
                <div className={styles.headerLeft}>
                {icon}
                <div className={`${styles.headerTitle} dark:text-white`}>{title}</div>
                </div>
                <div className={styles.notificationBadge}>{count} new</div>
            </div>
            </div>
            <div className={styles.cardContent}>
            <div className="d-flex flex-direction-column flex-center">
                <div className="mt-35">
                <ChatBubbleOutlineOutlinedIcon className="text-slate-300 dark:text-slate-400" fontSize="large" />
                </div>
                <div className="mt-10 text-[#64748B] dark:text-slate-300 text-base font-medium leading-5">
                Communication messages will be posted soon
                </div>
            </div>
            </div>
        </div>
        )}
    </>
    );
}


export default CommunicationsCard;